import axios from 'lib/utils/axios';
import logrocket from '@/services/logrocket';

import getTimezoneList from 'api/requests/timezone/getTimezoneList';

async function fetchTimezoneList({ commit, getters, rootGetters }) {
  try {
    const { data } = await getTimezoneList(axios);

    commit('SET_TIMEZONE_LIST', data);

    const currentTimezoneArea = getters.getTimezoneAreaList
      .find(area => area.id === rootGetters.getMerchantTimezone?.area_id) || null;

    commit('SET_CURRENT_TIMEZONE_AREA', currentTimezoneArea);
  } catch (error) {
    logrocket.logger(error);
    throw new Error(error);
  }
}

export default {
  fetchTimezoneList,
};
